export const ADD_BUYER = "ADD_BUYER";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const UPDATE_BUYER = "UPDATE_BUYER";
